import { lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { RequirePermission } from '@/auth/RequirePermission'
import { AUDIT_ENGAGEMENT_HOME, AUDIT_ENGAGEMENT_SECTIONS } from '@/lib/auditEngagements'
import { permissionCode } from '@/lib/permissions'

/**
 * Audit Engagements routes.
 *
 * The module no longer opens a landing page of tiles: the sidebar expands it
 * into its sections, so `/engagements` forwards to the first section and
 * every section keeps a deep-linkable URL of its own. Sections and routes are
 * generated from `AUDIT_ENGAGEMENT_SECTIONS`, so navigation, the sidebar
 * accordion and the URL space cannot drift apart.
 *
 * Each section is still a placeholder until that part of the workflow is
 * finalised; swapping its element is the only change needed then.
 */
const AuditEngagementSectionPlaceholder = lazy(
  () => import('@/pages/audit-engagements/AuditEngagementSectionPlaceholder'),
)

const viewPermission = permissionCode('audit_engagements', 'view')

export const auditEngagementRoutes: RouteObject[] = [
  {
    path: 'engagements',
    element: (
      <RequirePermission permission={viewPermission}>
        <Navigate to={AUDIT_ENGAGEMENT_HOME} replace />
      </RequirePermission>
    ),
  },
  ...AUDIT_ENGAGEMENT_SECTIONS.map<RouteObject>((section) => ({
    path: section.to.replace(/^\//, ''),
    element: (
      <RequirePermission permission={viewPermission}>
        <AuditEngagementSectionPlaceholder title={section.label} description={section.description} />
      </RequirePermission>
    ),
  })),
]
